import { ActiveProjectsCard } from "components/timesheet/dashboard/projects-coordinating/active-card";
import { EvtSectionHeader } from "components/header";
import { ProjectCoordinatorsPendingReviewHoursCard } from "components/timesheet/dashboard/projects-coordinating/pending-review-hours-card";
import React from "react";
import { withPermissions } from "components/with-permisisons";

const ProjectCoordinatorsSection = () => {
  return (
    <section className="mt-3.5">
      <EvtSectionHeader title="Projects Coordinating" />
      <div className=" lg:flex gap-y-4 lg:gap-y-6  items-center lg:flex-row grid sm:grid-cols-2 grid-cols-1 md:px-6 px-4 mt-4.5 ">
        <ActiveProjectsCard />
        <ProjectCoordinatorsPendingReviewHoursCard />
      </div>
    </section>
  );
};

export default ProjectCoordinatorsSection;
